<script setup lang="ts">
import type { Locales } from '@/services/types/api.types';
import { useField } from 'vee-validate';
import { computed, inject, ref, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';

const filePicker = ref<{ pickFiles: (evt?: Event) => void } | null>(null);
const { t } = useI18n();

const props = defineProps<{
  name: string;
  accept: string;
  file?: File;
}>();

const nameFr = computed(() => `${props.name}.fr`);
const nameEn = computed(() => `${props.name}.en`);

const { value: valueFr, errorMessage: errorMessageFr } = useField<File | null>(nameFr.value);
const { value: valueEn, errorMessage: errorMessageEn } = useField<File | null>(nameEn.value);

const editLocale = inject<Ref<Locales>>('editLocale');

function pickFiles() {
  if (filePicker.value) {
    filePicker.value.pickFiles();
  }
}
</script>

<template>
  <div class="localized-file">
    <q-file
      v-if="editLocale === 'fr'"
      v-model="valueFr"
      v-bind="$attrs"
      :multiple="true"
      :accept="accept"
      :error="!!errorMessageFr"
      :error-message="errorMessageFr"
      outlined
      bottom-slots
      ref="filePicker"
    >
      <template v-slot:before>
        <q-icon v-if="accept === 'image/*'" name="o_add_a_photo" />
        <q-icon v-else name="folder_open" />
      </template>
      <template v-slot:append>
        <q-icon name="add" @click="pickFiles" />
      </template>
    </q-file>
    <q-file
      v-else-if="editLocale === 'en'"
      v-model="valueEn"
      :accept="accept"
      :multiple="true"
      v-bind="$attrs"
      :error="!!errorMessageEn"
      :error-message="errorMessageEn"
      outlined
      ref="filePicker"
    >
      <template v-slot:before>
        <q-icon v-if="accept === 'image/*'" name="o_add_a_photo" />
        <q-icon v-else name="folder_open" />
      </template>
      <template v-slot:append>
        <q-icon name="add" @click="pickFiles" />
      </template>
    </q-file>
    <q-banner class="text-white bg-red q-mb-sm" v-if="!editLocale">Missing editLocale injection</q-banner>
  </div>
</template>
